import { ComponentType, SVGProps, createElement } from 'react';
import styled from 'styled-components';

export type IconProps = SVGProps<SVGSVGElement> & {
	size?: number;
	color?: string;
	ariaLabel?: string;
	solid?: boolean;
};

export type CreatedIcon = ComponentType<IconProps>;

export function createIcon(Stroke: ComponentType<IconProps>, Solid?: ComponentType<IconProps>) {
	function Icon({ solid, ...props }: IconProps) {
		const Glyph = solid && Solid ? Solid : Stroke;
		return createElement(Glyph, props);
	}

	return styled(Icon)`
		flex-shrink: 0;
		display: block;

		path[fill='none'] {
			fill: none !important;
		}
	`;
}
